import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { dtForInputDate, PageHeader } from './AuxiliaryFunctions';
import ExportSidebar from './ProSideBar';
import Sidebar from './Sidebar';
import { Col, Row, Container, Button, Alert, FormLabel, FormControl } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import DisponibilidadDataService from './services/disponibilidad.service';
import MessageBox from './MessageBox';

const ConfirmAvailability = () => {
	const location = useLocation();
	const { user: currentUser } = useSelector((state) => state.auth);	
	const [comments, setComments] = useState('');
	const [isLoading, setIsLoading] = useState(false);
  
	const [showerror, setShowerror] = useState(false);
	const [showsuccess, setShowsuccess] = useState(false);
	const [errmessage, setErrmessage] = useState('');
	const [succmessage, setSuccmessage] = useState('');

	const onConfirm = async ({currentUserId, eventId, startDate, endDate, comments }) => {
		DisponibilidadDataService.create({
			userId: currentUserId,
			competenciaId: eventId,
			fechainicialconfirmada: startDate,
			fechafinalconfirmada: endDate,
			comentariosdeljuez: comments
		})
		.then((data) => {
			setShowerror(false);
			setErrmessage("");
			setSuccmessage("Se ha creado la confirmación de disponibilidad!");
			setShowsuccess(true);
			window.location.assign('/competencias');
		})
		.catch((e) => {
			console.log(e);
			setSuccmessage("");
			setShowsuccess(false);
			setErrmessage(e.response.data?e.response.data.message: "Ocurrió un error.");
			setShowerror(true);
		})
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		const eventId = location.state?location.state.competencia.id:null;
		if (eventId) {
			console.log(location.state);
			try {
				await onConfirm({
					currentUserId: currentUser.id,
					eventId,
					startDate: location.state?location.state.competencia.fechainicio:null,
					endDate: location.state?location.state.competencia.fechafin:null,
					comments
				});
			} finally {
				setIsLoading(false);
			}
		}
	};

	const onCancel = () => {
		window.location.assign('/competencias');
	};

	return (
	<>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>      
    	<ExportSidebar roles={currentUser.roles}/>
        <Container>
	        <PageHeader />
			<Container>
				<h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Confirmar disponibilidad</h4>
			</Container>
			<Row>

				<div
					className="card"
					style={{padding:'40px 40px',}}
				>
					<form onSubmit={handleSubmit}>
						
						<div style={{ marginBottom: '20px' }}>
							<Alert>
								Muchas gracias por tu interés en esta competencia. Al confirmar tu disponibilidad aparecerás en la lista de jueces disponibles y un administrador puede seleccionarte para participar como juez en la competencia.
							</Alert>
						</div>

						<Col className='col-md-3' md={4}>
							<FormLabel className='mb-2'>Nombre competencia:</FormLabel>       
							<FormControl 
								disabled
								style={{maxWidth:"300px"}} 
								type="text" 
								name="nombrecompetencia" 
								id="nombrecompetencia"
								value={location.state?location.state.competencia.nombrecompetencia:null}
							/>
						</Col>

						<Col className='col-md-3' sm={8}>
						<FormLabel className="mr-5" htmlFor="fecha-inicio">Fecha inicial:</FormLabel>
						<FormControl 
							disabled
							className="form-control" 
							id="fecha-inicio" 
							type="date" 
							data-date="" 
							data-date-format="DD-MM-YYYY"
							value={location.state?dtForInputDate(location.state.competencia.fechainicio):null}
						/>
						</Col>    

						{/**
						<Col className='col-md-3' sm={8}>
						<FormLabel className="mr-5" htmlFor="fecha-fin">Fecha final:</FormLabel>
						<FormControl 
							disabled
							className="form-control" 
							id="fecha-fin" 
							type="date" 
							data-date="" 
							data-date-format="DD-MM-YYYY"
							value={location.state?dtForInputDate(location.state.competencia.fechafin):null}
						/>
						</Col>                            
						*/}



					<Row>
						<Col md={12}>
						<FormLabel className='mb-2'>Descripción competencia:</FormLabel>       
						<FormControl 
							disabled
							type="text" 
							name="descripcioncompetencia" 
							id="descripcioncompetencia"
							value={location.state?location.state.competencia.descripcioncompetencia:null}
						/>
						</Col>
					</Row>
					

						<div style={{ marginBottom: '20px' }}>
							<label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
								Comentarios:
							</label>
							<textarea
								value={comments}
								onChange={(e) => setComments(e.target.value)}
								placeholder="Agrega información adicional."
								style={{
									width: '100%',
									padding: '10px',
									borderRadius: '4px',
									border: '1px solid #ccc',
									fontFamily: 'inherit'
								}}
								rows="4"
							/>
						</div>

						<div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
							<button
								className='btn btn-primary'
								type="button"
								onClick={onCancel}

							>
								Cancelar
							</button>
							<button
								className='btn btn-success'
								type="submit"
							>
								{isLoading ? 'Confirming...' : 'Confirmar'}
							</button>
						</div>
					</form>
				</div>
			</Row>
		</Container>
	</div>
	<Row className='mt-2'>

		{showerror && (
		<MessageBox show={true} showerror={showerror} errmessage={errmessage}
			onHide={() => {
			setShowerror(false)
			}}
		/>
		)}
		{showsuccess && (

		<MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
			onHide={() => {
			setShowsuccess(false);
			window.location.reload();
		}}
		/>
		)}

	</Row> 
	</>
	);
};

export default ConfirmAvailability;